import { Injectable, Output, EventEmitter } from "@angular/core";
import { BehaviorSubject, Subject, Observable } from "rxjs";

@Injectable()
export class DataService {
  @Output() public getNotifications = new EventEmitter<boolean>();
  private dataSource = new BehaviorSubject("");
  currentMessage = this.dataSource.asObservable();
  private notify = new Subject<any>();


  private breadCrumb = new BehaviorSubject({});
  breadCrumbData = this.breadCrumb.asObservable();
  /**
   * Observable string streams
   */
  notifyObservable$ = this.notify.asObservable();

  constructor() {}

  /** Message change Observable to show result on other component*/
  changeMessage(data: any) {
    this.dataSource.next(data);
  }
  /**Set Observable to show result on other component*/
  set(set: any, key: string) {
    this.notify.next({ set: set, key: key });
  }

  /**get Observable to show result on other component*/
  get(): Observable<any> {
    return this.notify.asObservable();
  }
  /** Message change Observable to show result on other component*/
  dataSent(data: any, key: string='') {
    this.notify.next({ data: data, key: key });
  }
  dataRecieved(): Observable<any> {
    return this.notify.asObservable();
  }

  setbreadCrumb(data:any){
    this.breadCrumb.next(data)
  }

  getbreadCrumb(){
    return this.breadCrumb.asObservable();
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }
}
